export default "__VITE_ASSET__Cx90En$L__"